﻿
(function ($, d, ns) {

    ns.InitializePriceSlider = function () {
        var $txtPriceFrom = $('.js-price-from');
        var $txtPriceTo = $('.js-price-to');
        var $btnUpdate = $('.js-products-price');
        var priceFrom = $txtPriceFrom.data('original-value') || 0;
        var priceTo = $txtPriceTo.data('original-value') || 500;

        if ($(".js-price-slider").length) {
            $(".js-price-slider").slider({
                range: true,
                min: 0,
                max: 500,
                values: [priceFrom, priceTo],
                slide: function (event, ui) {
                    $txtPriceFrom.val(ui.values[0]);
                    if (ui.values[1] < 500) {
                        $txtPriceTo.val(ui.values[1]);
                    } else {
                        $txtPriceTo.val("500+");
                    }
                }
            });
        }

    };

    $(d).ready(function () {
        ns.InitializePriceSlider();
    });

})(jQuery, document, Crafted.Utilities);